import script from "./TreeElement.vue?vue&type=script&setup=true&lang=js"
export * from "./TreeElement.vue?vue&type=script&setup=true&lang=js"

import "./TreeElement.vue?vue&type=style&index=0&id=043845cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-043845cf"]])

export default __exports__